import L from "leaflet";

L.PredictionIcon = L.DivIcon.extend({
  background: function(color) {
    if (color === '#228b22' ) {
      return 'url("/img/gradients/verygood.png")';
    } else if (color === '#94a60d') {
      return 'url("/img/gradients/good.png")';
    } else if (color === '#ffd700') {
      return 'url("/img/gradients/moderate.png")';
    } else if (color === '#ff8c00') {
      return 'url("/img/gradients/sufficient.png")';
    } else if (color === '#ff0000') {
      return 'url("/img/gradients/bad.png")';
    } else if (color === '#8b0000') {
      return 'url("/img/gradients/verybad.png")';


    } else if (color === '#58b109' ) {
      return 'url("/img/gradients/cluster_verygood.png")';
    } else if (color === '#94a60d') {
      return 'url("/img/gradients/cluster_good.png")';
    } else if (color === '#ffc900') {
      return 'url("/img/gradients/cluster_moderate.png")';
    } else if (color === '#edb238') {
      return 'url("/img/gradients/cluster_sufficient.png")';
    } else if (color === '#e60008') {
      return 'url("/img/gradients/cluster_bad.png")';
    } else if (color === '#990a0f') {
      return 'url("/img/gradients/cluster_verybad.png")';
    }
  },
  isDomExists: function() {
    if (this.dom !== undefined) {
      return true;
    } else {
      return false;
    }
  },
  setColor: function(color) {
    if (this.dom !== undefined) {
      if (color !== this.options.color) {
        if (this.firstLayer.style.opacity == this.opacity && this.secondLayer.style.opacity == 0) {
          this.secondLayer.style.backgroundImage = this.background(color);
          this.secondLayer.style.transition = 'opacity 0.5s';
          this.secondLayer.style.opacity = this.opacity;

          this.firstLayer.style.transition = 'opacity 0.5s';
          this.firstLayer.style.opacity = 0;  
        } else if (this.firstLayer.style.opacity == 0 && this.secondLayer.style.opacity == 0) {
          this.secondLayer.style.backgroundImage = this.background(color);
          this.secondLayer.style.transition = 'opacity 0.5s';
          this.secondLayer.style.opacity = this.opacity;

          this.firstLayer.style.transition = 'opacity 0.5s';
          this.firstLayer.style.opacity = 0;     
        } else if (this.secondLayer.style.opacity == this.opacity && this.firstLayer.style.opacity == 0) {
          this.firstLayer.style.backgroundImage = this.background(color);
          this.firstLayer.style.transition = 'opacity 0.5s';
          this.firstLayer.style.opacity = this.opacity;

          this.secondLayer.style.transition = 'opacity 0.5s';
          this.secondLayer.style.opacity = 0;
        }

        this.options.color = color;
      }
    }
  },
  createIcon: function() {
    let zoom = this.options.zoom;
    let opacity = (0.035 * zoom).toFixed(2);
    let defaultSize = Math.pow(1.18, zoom);
    let markerWidth = defaultSize * 17;
    let markerHalfWidth = Math.round(markerWidth / 2);

    var iconDiv = document.createElement("div");
    iconDiv.style.position = 'absolute';
    iconDiv.style.pointerEvents = 'none';
    iconDiv.style.width =  markerWidth + 'px';
    iconDiv.style.height = markerWidth + 'px';
    iconDiv.style.marginLeft = "-" + markerHalfWidth + 'px';
    iconDiv.style.marginTop = "-" + markerHalfWidth + 'px';
    iconDiv.style.borderRadius = '15px';
    iconDiv.style.background = 'none';

    var firstLayer = document.createElement("div");
    firstLayer.style.position = 'absolute';
    firstLayer.style.pointerEvents = 'none';
    firstLayer.style.opacity = opacity;
    firstLayer.style.width =  markerWidth + 'px';
    firstLayer.style.height = markerWidth + 'px';
    firstLayer.style.transition = 'opacity 0.5s';
    firstLayer.style.backgroundSize = 'cover';
    firstLayer.style.borderRadius = '50px';

    var secondLayer = document.createElement("div");
    secondLayer.style.position = 'absolute';
    secondLayer.style.pointerEvents = 'none';
    secondLayer.style.opacity = '0';
    secondLayer.style.width =  markerWidth + 'px';
    secondLayer.style.height = markerWidth + 'px';
    secondLayer.style.backgroundSize = 'cover';
    secondLayer.style.borderRadius = '50px';

    iconDiv.append(firstLayer);
    iconDiv.append(secondLayer);
    
    
    this.transparentSize = defaultSize + 45;
    if (this.options.color !== null) {
      firstLayer.style.backgroundImage = this.background(this.options.color);
    }

    this.firstLayer = firstLayer;
    this.secondLayer = secondLayer;
    this.dom = iconDiv;
    this.opacity = opacity;
    this._setIconStyles(this.dom, 'div');

    return this.dom;
  }
});

L.predictionIcon = function(options) {
  return new L.PredictionIcon(options);
};


